import ManageIntegrations from './ManageIntegrations.container';

export default ManageIntegrations;
